/* eslint-disable prettier/prettier */
import Component from '../abstracts/Component';
import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';
//END WIP
import wnumb from 'wnumb';
import nouislider from "nouislider";

export const SLIDER_EVENTS = {
    handlePrice: 'slider:handlePrice',
    reset: 'slider:reset',
    refresh: 'slider:refresh',
    updateMinMax: 'slider:updateMinMax',
}

export default class PriceRangeComponent extends Component {
  get SELECTORS() {
    return {
      sliderList: '[data-slider]',
    }
  }

  constructor( compEl ) {
    super(compEl);

    this.sliderList = document.querySelectorAll(this.SELECTORS.sliderList)
    this.minSelected = undefined
    this.maxSelected = undefined

  }

  bindEvents() {
    console.warn('PriceRangeComponent binding events')
    if (this.sliderList) {
      this.sliderList.forEach(slider => {
        let stepList = [0];
        Object.entries(slider?.dataset)?.forEach(([k, v]) => { if (k.startsWith('filter-')) stepList.push(parseInt(v)) })
        
        let {
          referenceValue,
          maxSelected
        } = slider?.dataset ?? { referenceValue: '', minValue: 0, maxValue: 0}
            
        let urlSearchParams = new URLSearchParams(window.location.search);
        const min = urlSearchParams.get("min") ?? ""
        let max = maxSelected ? maxSelected : (stepList ? stepList[stepList.length - 1] : 0)
        let currency = slider.getAttribute("data-currency"); 
        let range = {
          min: 0,
          max: stepList[stepList.length - 1]
        };
        const filteredStepList = stepList.filter((step) => (step !== 0) && (step !== max))
        const perc = Number.parseFloat((100 / stepList.length).toFixed(2));
        let oldPerc = 0;
        for (const step of filteredStepList) {
          range[`${(oldPerc + perc)}%`] = step;
          oldPerc = Number.parseFloat((oldPerc + perc).toFixed(2));
        }
        let options = {
          start: [min, max],
          connect: true,
          snap: true,
          range: range,
          tooltips: {
            format: wnumb({decimals: 0}),
            to: function(value) { return Math.trunc(value) + currency }
          }
        }
        
        if (slider.noUiSlider) {
          slider.noUiSlider.updateOptions(options);
        } else {
          noUiSlider.create(slider, options);
        } 

        this.mergeTooltips(slider, 15, '-');

        let that = this

        if (slider.noUiSlider) {
          slider.noUiSlider.on('change', function (v) {
            let selectedSteps = []
  
            stepList.forEach(step => {
              if (step >= v[0] && step <= v[1]) {
                selectedSteps.push(step)
              }
            })

            that.$emit(SLIDER_EVENTS.handlePrice, { id: slider.id, selectedSteps, min: v[0], max: v[1], referenceValue });
  
          });
        }

      })

      let sliderList = this.sliderList
      let that = this
      this.$on(SLIDER_EVENTS.reset, ({payload}) => {
        console.warn('Slider reset')
        
        let slider = null;
        sliderList.forEach(s => {
          if (`slider-${payload.id}` === s.id) slider = s
        })
  
        if (slider) {
          let stepList = [];

          Object.entries(slider?.dataset)?.forEach(([k, v]) => { if (k.startsWith('filter-')) stepList.push(parseInt(v))})
    
          const min = 0
          const max = stepList ? stepList[stepList.length - 1] : 0

          let range = {
            min: 0,
            max: stepList[stepList.length - 1]
          };
          const filteredStepList = stepList.filter((step) => (step !== 0) && (step !== max))
          const perc = (100 / stepList.length);
          let oldPerc = 0;
          for (const step of filteredStepList) {
            range[`${(oldPerc + perc)}%`] = step;
            oldPerc = oldPerc + perc;
          }
    
          let options = {
            start: [min, max],
            connect: true,
            snap: true,
            range: range,
            tooltips: {
              fromat: wnumb({decimals: 0}),
              to: function(value) { return Math.trunc(value) + ' €'; }
            }
          }
          slider.noUiSlider.updateOptions(options);
          
          that.$emit(SLIDER_EVENTS.updateMinMax, { id: slider.id, min, max });
        }
      })

      this.$on(SLIDER_EVENTS.refresh, ({payload}) => {
        console.warn('Slider refresh')

        let slider = null;
        sliderList.forEach(s => {
          if (`slider-${payload.id}` === s.id) slider = s
        })
  
        if (slider) {
          let stepList = [];
          Object.entries(payload?.dataset)?.forEach(([k, v]) => { if (k.startsWith('filter-')) stepList.push(parseInt(v)) })
              
          const min = 0
          const max = payload.max ? payload.max : (stepList ? stepList[stepList.length - 1] : 0)

          let range = {
            min: 0,
            max: stepList[stepList.length - 1]
          };
          const filteredStepList = stepList.filter((step) => (step !== 0) && (step !== max))
          const perc = (100 / stepList.length);
          let oldPerc = 0;
          for (const step of filteredStepList) {
            range[`${(oldPerc + perc)}%`] = step;
            oldPerc = oldPerc + perc;
          }
    
          let options = {
            start: [min, max],
            connect: true,
            snap: true,
            range: range,
            tooltips: {
              fromat: wnumb({decimals: 0}),
              to: function(value) { return Math.trunc(value) + ' €'; }
            }
          }

          if (slider.noUiSlider) {
            slider.noUiSlider.updateOptions(options);
          } else {
            noUiSlider.create(slider, options);
          }
        }
      })
    }
  }

  /**
   * @param slider HtmlElement with an initialized slider
   * @param threshold Minimum proximity (in percentages) to merge tooltips
   * @param separator String joining tooltips
   */
  mergeTooltips(slider, threshold, separator) {
    const textIsRtl = getComputedStyle(slider).direction === 'rtl';
    const isRtl = slider.noUiSlider.options.direction === 'rtl';
    const isVertical = slider.noUiSlider.options.orientation === 'vertical';
    let tooltips = slider.noUiSlider.getTooltips();
    let origins = slider.noUiSlider.getOrigins();
    let currency = slider.getAttribute("data-currency"); 

    // Move tooltips into the origin element. The default stylesheet handles this.
    tooltips.forEach(function (tooltip, index) {
      if (tooltip) {
        origins[index].appendChild(tooltip);
      }
    });

    slider.noUiSlider.on('update', function (values, handle, unencoded, tap, positions) {
      let pools = [[]];
      let poolPositions = [[]];
      let poolValues = [[]];
      let atPool = 0;

      // Assign the first tooltip to the first pool, if the tooltip is configured
      if (tooltips[0]) {
        pools[0][0] = 0;
        poolPositions[0][0] = positions[0];
        poolValues[0][0] = values[0];
      }

      for (let i = 1; i < positions.length; i++) {
        if (!tooltips[i] || (positions[i] - positions[i - 1]) > threshold) {
          atPool++;
          pools[atPool] = [];
          poolValues[atPool] = [];
          poolPositions[atPool] = [];
        }

        if (tooltips[i]) {
          pools[atPool].push(i);
          poolValues[atPool].push(values[i]);
          poolPositions[atPool].push(positions[i]);
        }
      }

      pools.forEach(function (pool, poolIndex) {
        let handlesInPool = pool.length;

        for (let j = 0; j < handlesInPool; j++) {
          let handleNumber = pool[j];

          if (j === handlesInPool - 1) {
            let offset = 0;

            poolPositions[poolIndex].forEach(function (value) {
              offset += 1000 - value;
            });

            let direction = isVertical ? 'bottom' : 'right';
            let last = isRtl ? 0 : handlesInPool - 1;
            let lastOffset = 1000 - poolPositions[poolIndex][last];
            offset = (textIsRtl && !isVertical ? 100 : 0) + (offset / handlesInPool) - lastOffset;

            // Center this tooltip over the affected handles
            let formattedPoolValues = [];
            poolValues[poolIndex].forEach((val) => {
              if (!(formattedPoolValues[poolIndex])) formattedPoolValues[poolIndex] = [];
              formattedPoolValues[poolIndex].push(Math.trunc(val) + currency);
            });
            tooltips[handleNumber].innerHTML = formattedPoolValues[poolIndex].join(separator);
            tooltips[handleNumber].style.display = 'block';
            tooltips[handleNumber].style[direction] = offset + '%';
          } else {
            // Hide this tooltip
            tooltips[handleNumber].style.display = 'none';
          }
        }
      });
    });
  }

  render() {
    super.render();
    this.bindEvents();
  }

}

// OLD: if ok, remove
export class PriceRangeComponent_old extends Component {
  get SELECTORS() {
    return {
      minInput: '.w-price-range [data-input-min]',
      minText: '.w-price-range [data-text-min]',
      maxInput: '.w-price-range [data-input-max]',
      maxText: '.w-price-range [data-text-max]',
      rangeSlider: '.w-price-range [data-range-slider]',
      resetBtn: '.w-price-range [data-range-reset]',
      //END WIP
      rangerBar: '.w-price-range',
      inputMin: '.w-price-range .input-min',
      inputMax: '.w-price-range .input-max',
      oldInputMin: '.w-price-range .old-input-min',
      oldInputMax: '.w-price-range .old-input-max',
    };
  }

  get CSS_CLASSNAMES() {
    return {
      minValueSet: 'c-p-r__min-value-set',
      maxValueSet: 'c-p-r__max-value-set',
      //END WIP
      active: 'active',
    };
  }

  constructor(compEl) {
    super(compEl);
    //call on document to avoid NaN when resetFilters
    if (document.querySelector('.w-price-range')) {
      this.minVal = parseInt(document.querySelector('.w-price-range').dataset.rangeMin);
      this.maxVal = parseInt(document.querySelector('.w-price-range').dataset.rangeMax);
      this.currentMin = parseInt(document.querySelector('.w-price-range').dataset.min);
      this.currentMax = parseInt(document.querySelector('.w-price-range').dataset.max);
    }
    this.minText = this.$component.querySelector(this.SELECTORS.minText);
    this.maxText = this.$component.querySelector(this.SELECTORS.maxText);
    this.minInput = this.$component.querySelector(this.SELECTORS.minInput);
    this.maxInput = this.$component.querySelector(this.SELECTORS.maxInput);
    this.resetBtn = document.querySelector(this.SELECTORS.resetBtn);
    this.rangeSlider = this.$component.querySelector(
      this.SELECTORS.rangeSlider
    );
    this.resetSlider = this.resetSlider.bind(this);
    //END WIP
    this.rangerBar = this.$component.querySelector(this.SELECTORS.rangerBar);
    this.inputMin = this.$component.querySelector(this.SELECTORS.inputMin);
    this.inputMax = this.$component.querySelector(this.SELECTORS.inputMax);
    this.oldInputMin = this.$component.querySelector(this.SELECTORS.oldInputMin);
    this.oldInputMax = this.$component.querySelector(this.SELECTORS.oldInputMax);
  }

  render() {
    super.render();
    this.init();
    this.setSliderChangeHandler();
    //END WIP
    // launch slider
    if (this.rangerBar != null) {
      this.initSlider(this.rangerBar);
    }
    // TODO: Fix slider init
    window.addEventListener('load', () => {
      this.bindEvents();
    });
  }

  init() {
    this.updateTexts();
    this.updateInputs();
    noUiSlider.create(this.rangeSlider, {
      start: [this.currentMin, this.currentMax],
      connect: true,
      range: {
        min: this.minVal,
        max: this.maxVal,
      },
      step: 10,
      format: {
        from: function (value) {
          return Number(value)
            .toString()
            .replace('.-', '');
        },
        to: function (value) {
          return Number(value)
            .toString()
            .replace('.-', '');
        },
      },
    });
  }

  renderNewSlider() {
    this.init();
    this.setSliderChangeHandler();
    // launch slider
    if (this.rangerBar != null) {
      this.initSlider(this.rangerBar);
    }
  }

  setSliderChangeHandler() {
    this.rangeSlider.noUiSlider.on('update', () => {
      var values = this.rangeSlider.noUiSlider.get();
      this.currentMin = parseInt(values[0]);
      this.currentMax = parseInt(values[1]);
      this.updateTexts();
      this.updateInputs();
      this.toggleResetVisibility(
        this.currentMin != this.minVal || this.currentMax != this.maxVal
      );
    });
    this.resetBtn.addEventListener('click', this.resetSlider);
  }

  updateTexts() {
    this.minText.innerHTML = this.currentMin.toString().replace('.-', '');
    this.maxText.innerHTML = this.currentMax.toString().replace('.-', '');
    if (this.currentMin == this.minVal) {
      this.$component.classList.remove(this.CSS_CLASSNAMES.minValueSet);
    } else {
      this.$component.classList.add(this.CSS_CLASSNAMES.minValueSet);
    }
    if (this.currentMax == this.maxVal) {
      this.$component.classList.remove(this.CSS_CLASSNAMES.maxValueSet);
    } else {
      this.$component.classList.add(this.CSS_CLASSNAMES.maxValueSet);
    }
  }

  updateInputs() {
    this.minInput.value = this.currentMin.toString().replace('.-', '');
    this.maxInput.value = this.currentMax.toString().replace('.-', '');
  }

  resetSlider() {
    if (this.rangeSlider == null) {
      this.rangeSlider = document.querySelector(this.SELECTORS.rangeSlider);
      if (this.rangeSlider == null) {
        return;
      }
    }
    this.rangeSlider.noUiSlider.set([this.minVal, this.maxVal]);
    this.toggleResetVisibility(false);
  }

  toggleResetVisibility(show) {
    if (show) {
      this.resetBtn.style.opacity = 1;
    } else {
      this.resetBtn.style.opacity = 0;
    }
  }

  //END WIP
  getAllRanges(element) {
    if (element != null) {
      // let's take data
      let data = element.dataset;
      // vars
      let all = data["all"];
      let allSplitted = all.split("|");
      // ascending order set
      const sortAsc = (a, b) => a - b;
      allSplitted.sort(sortAsc);
      //
      return allSplitted;
    }
  }

  // range functions
  getOptions(sliderElement) {
    // let's take data
    let data = sliderElement.dataset;
    // vars
    let rangeAllSliders = {};
    let allSplitted = this.getAllRanges(sliderElement);
    //
    let cnt = allSplitted.length;
    let setMinIndexTo = 0;
    let setMaxIndexTo = cnt - 1;
    let facetName = data['facetName'];
    let rangeMin = data['rangeMin'];
    let rangeMax = data['rangeMax'] || 100;
    // Set start min and start max from current query
    let currentQuery = data['currentQuery'];
    let setMinTo = undefined;
    let setMaxTo = undefined;
    let currency = sliderElement.getAttribute("data-currency");
    //
    if (currentQuery) {
      let rx = new RegExp("(:" + facetName + ":([0-9]+))", "g");
      let matches = currentQuery.match(rx);
      if (matches) {
        setMinTo = data['min'];
        setMaxTo = data['max'];
      }
    }
    // Otherwise from html
    if (!setMinTo) {
      setMinTo = sliderElement.querySelector(".input-min").value;
    }
    if (!setMaxTo) {
      setMaxTo = sliderElement.querySelector(".input-max").value;
    }
    /**
     *
     * E.g.
     * var range_all_sliders = {
     *   min: 0,
     *   '16%': 140,
     *   '25%': 150,
     *   '33%': 160,
     *   '42%': 170,
     *   '50%': 180,
     *   '58%': 190,
     *   '67%': 200,
     *   '75%': 220,
     *   '83%': 230,
     *   '91%': 260,
     *   max: 290,
     * }
     *
     */
    // if splitted is more than 2 intervals
    if (cnt >= 2) {
      for (var i = 0; i < cnt; i++) {
        let perc = Math.floor(100 * i / (cnt - 1));
        if (i == setMinIndexTo) {
          rangeAllSliders["min"] = parseInt(allSplitted[i]);
        } else if (i == setMaxIndexTo) {
          rangeAllSliders["max"] = parseInt(allSplitted[i]);
        } else {
          rangeAllSliders[perc + "%"] = parseInt(allSplitted[i]);
        }
      }
    }

    // build opts
    let opts = {
      start: [setMinTo || rangeMin, setMaxTo || rangeMax],
      connect: data['connect'] || true,
      snap: data['snap'] || true,
      range: rangeAllSliders,
      tooltips: true,
      format: wnumb({
        'decimals': 0,
        'thousand': '',
        'postfix': ' ' + currency
      }),
      pips: {
        mode: 'range'
      }
    };

    console.info("[Ranges] Slider init with opts: ", opts);

    return opts;
  }


  initSlider(slider) {
    // take options
    let ctx = this;
    let opts = this.getOptions(slider);
    let currency = slider.getAttribute("data-currency");

    // launch slider
    nouislider.create(slider, opts);

    // remove extra marker
    let noUinormals = slider.querySelectorAll(".noUi-marker-normal,.noUi-value-horizontal");
    if (noUinormals != null) {
      noUinormals.forEach(single => {
        single.remove();
      });
    }

    // change slider
    slider.noUiSlider.on('change', function (values, handle) {
      // vars
      let oldMinVal = ctx.oldInputMin.value;
      let oldMaxVal = ctx.oldInputMax.value;
      let minVal = values[0].replace(currency, '').trim();
      let maxVal = values[1].replace(currency, '').trim();
      // setting values
      ctx.inputMin.value = minVal;
      ctx.inputMax.value = maxVal;
      // Logging
      console.debug("[Ranges]: minVal " + minVal + " oldMinVal " + oldMinVal);
      console.debug("[Ranges]: maxVal " + maxVal + " oldMaxVal " + oldMaxVal);
      // Save curr values as old ones
      slider.querySelector(".old-input-min").value = minVal;
      slider.querySelector(".old-input-max").value = maxVal;
    });
  }

  updateSlider(response) {
    let updatedRangerBar = response.querySelector(this.SELECTORS.rangerBar);
    let updatedMin = response.querySelector(this.SELECTORS.inputMin);
    let updatedMax = response.querySelector(this.SELECTORS.inputMax);
    // data-min data-max data-current-query
    // setting values
    this.inputMin.value = updatedMin.value;
    this.inputMax.value = updatedMax.value;


    let newOpts = this.getOptions(updatedRangerBar);

    this.rangerBar.noUiSlider.updateOptions(
      newOpts, // Object
      true // Boolean 'fireSetEvent'
    );

  }

  buildQuery(isReset) {
    // take values
    if (document.querySelector('.w-price-range') == null) {
      return '';
    }
    this.rangerBar = document.querySelector('.w-price-range');
    let allSplitted = this.getAllRanges(this.rangerBar);

    let minVal = this.rangerBar.querySelector('[data-input-min]').value;
    let maxVal = this.rangerBar.querySelector('[data-input-max]').value;
    let rangeMin = this.rangerBar.getAttribute("data-range-min");
    let rangeMax = this.rangerBar.getAttribute("data-range-max");
    let facetName = this.rangerBar.getAttribute("data-facet-name");

    let query = '';
    let count;
    
    if ((rangeMin != minVal || rangeMax != maxVal) && !isReset) {
      query = ':';
      for (var i = 0; i < allSplitted.length; i++) {
        if (parseInt(allSplitted[i]) <= minVal) {
          // if is less , i jumpt it
          continue;
        } else if ((parseInt(allSplitted[i]) <= maxVal) && count == null) {
          // first price filter
          query += facetName + ":" + allSplitted[i];
          count = 1;
        } else if ((parseInt(allSplitted[i]) <= maxVal) && count != null) {
          // first price filter
          query += ":" + facetName + ":" + allSplitted[i];
        } else {
          break;
        }
      }
      if (query == ':') {
        //avoids broken query
        query += facetName + ":" + maxVal;
      }
    } else {
      query = '';
    }
    return query;
  }

  //TODO: fix slider init
  bindEvents() {
    this.$on(this.$customEvents.FILTERS_EVENTS.filtersReset, () => {
      // reset sliders
      this.initSlider(document.querySelector(this.SELECTORS.rangerBar));
    });
  }

}
